import { useLoggedInUser } from "@/user/LoggedInUserProvider";
import { createContext, ReactNode, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

interface FirmContextType {
    hasFirmId: boolean;
    firmId: string;
    setFirmId: (firmId: string) => void;
}

const FirmContext = createContext<FirmContextType>({
    hasFirmId: false,
    firmId: "",
    setFirmId: () => undefined
});

const STORAGE_KEY = "firmId";

export const useFirmId = () => {
    return useContext(FirmContext);
};

export const FirmProvider = ({ children }: { children: ReactNode }) => {
    const navigate = useNavigate();
    const { firmIds } = useLoggedInUser();

    const [selectedFirmId, setSelectedFirmId] = useState(() =>
        localStorage.getItem(STORAGE_KEY)
    );

    const firmId =
        selectedFirmId && firmIds.includes(selectedFirmId)
            ? selectedFirmId
            : firmIds.length > 0
              ? firmIds[0]
              : undefined;

    const setFirmId = (firmId: string) => {
        localStorage.setItem(STORAGE_KEY, firmId);
        setSelectedFirmId(firmId);
        void navigate("/");
    };

    const contextValue: FirmContextType = {
        hasFirmId: !!firmId,
        firmId: firmId ?? "",
        setFirmId
    };

    return (
        <FirmContext.Provider value={contextValue}>
            {children}
        </FirmContext.Provider>
    );
};
